export const styles = {
     // Modal container styles
     modalContainer: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 600,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
     },

     // Drawer styles
     drawer: {
          width: { xs: '100vw', sm: '500px', md: '600px', lg: '700px' },
          maxWidth: '100vw',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
     },

     // Header styles
     header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 2,
          backgroundColor: '#fff',
     },
     title: {
          fontWeight: 'bold',
          color: '#1C2B36',
     },

     // Content styles
     content: {
          overflow: 'hidden',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          transition: 'gap 0.3s ease-in-out',
     },

     // Fixed sections styles
     fixedSections: {
          padding: 3,
          paddingBottom: 2,
          backgroundColor: '#fff',
          zIndex: 1,
          transition: 'margin-bottom 0.3s ease-in-out',
     },

     sectionTitle: {
          fontWeight: 'bold',
          color: '#2A3F4D',
          marginTop: 1,
     },

     // Task description styles
     taskDescription: {
          color: '#666',
          fontStyle: 'italic',
          marginTop: 2
     },

     // Task selector header styles
     taskSelectorHeader: {
          display: 'flex',
          gap: 1,
     },
     taskSelectorIconButton: {
          marginTop: "10px"
     },

     // Actions styles
     actions: {
          px: 3,
          py: 2,
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          transition: 'padding-top 0.3s ease-in-out',
     },

     // Form styles
     select: {
          bgcolor: '#FAFBFC',
          '& .MuiInputBase-root': {
               fontSize: '16px',
               fontFamily: 'Karla, sans-serif',
               fontWeight: 400,
               lineHeight: '24px',
               color: '#1C2B36',
               borderBottom: '1px solid #3E5463',
               '&:before': {
                    display: 'none',
               },
               '&:after': {
                    borderBottom: '1px solid #3E5463',
               },
               '&:hover:not(.Mui-disabled):before': {
                    display: 'none',
               },
          },
          '& .MuiInputLabel-root': {
               fontSize: '14px',
               fontFamily: 'Karla, sans-serif',
               fontWeight: 500,
               color: '#3E5463',
          },
          '& .MuiSelect-icon': {
               color: '#3E5463',
          },
     },
     actionButton: {
          borderColor: '#005DAA',
          color: '#005DAA',
          '&:hover': {
               borderColor: '#005DAA',
               backgroundColor: 'rgba(0, 93, 170, 0.04)',
          },
     },

     // Styles for MilestoneForm component
     inputContainer: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          alignItems: 'center',
          height: '40px',
          px: 2,
          py: 2.5,
          bgcolor: '#FFFFFF',
     },
     newMilestoneInput: {
          flex: 1,
          '& .MuiInputBase-root': {
               bgcolor: '#FAFBFC',
               borderBottom: '1px solid #3E5463',
               '&:before': {
                    display: 'none',
               },
               '&:after': {
                    display: 'none',
               },
          },
     },
     addMilestoneActions: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '50px',
          px: 0,
          py: 2.5,
     },
}; 